import React from "react"
import { useParams } from "react-router-dom"

import { Container, Grid, Typography } from "@material-ui/core"
import { Autorenew } from "@material-ui/icons"
import { Notification } from "@/components"

import useValidation, { ErrorType } from "@/hooks/useValidation"
import { GenericStringQueryParams } from "@/protocols/utility"
import ErrorHandlerService from "@/services/ErrorHandler"
import ApiService from "@/services/Api"

import useStyles from "@/pages/Admin/TrackableLinks/RedirectToWhatsAppFromATrackableLink/styles"
import useCustomStyles from "@/styles/custom"
import useDidMount from "@/hooks/useDidMount"
import useQuery from "@/hooks/useQuery"

type RedirectToWhatsAppParams = {
	linkHash: string
	linkSlug: string
}

type RegisterInteractionResponse = {
	messageWithInteractionId: string
	inboxChannelPhoneNumber: string
}

const RedirectToWhatsAppFromATrackableLink: React.FC = () => {
	const classes = useStyles()
	const customStyles = useCustomStyles()

	const { triggerValidation } = useValidation()
	const { linkHash, linkSlug } = useParams<RedirectToWhatsAppParams>()

	const query = useQuery()

	const handleRegisterInteraction = async () => {
		const url = window.location.origin
		const params = {} as GenericStringQueryParams

		query.forEach((value, key) => {
			params[key] = value
		})

		try {
			const { data } = await ApiService.post<RegisterInteractionResponse>(`/trackable-links/${linkHash}/interactions`, {
				url,
				slug: linkSlug,
				linkAttributesParams: {
					...params
				}
			})

			const whatsappUrl = new URL("https://api.whatsapp.com/send")
			const allParams = {
				phone: data.inboxChannelPhoneNumber,
				text: data.messageWithInteractionId,
				...params
			}

			Object.entries(allParams).forEach(([key, value]) => {
				whatsappUrl.searchParams.set(key, value)
			})

			window.location.replace(whatsappUrl.toString())
		} catch (error) {
			Notification.error({ message: "Ocorreu um erro ao te redirecionar" })
			triggerValidation(error as ErrorType)
			ErrorHandlerService.handle(error as ErrorType)
		}
	}

	useDidMount(async () => {
		await handleRegisterInteraction()
	})

	return (
		<Container maxWidth="md">
			<Grid
				container
				direction="column"
				justifyContent="center"
				alignItems="center"
				spacing={2}
				className={classes.gridContainer}
			>
				<Grid item>
					<Autorenew className={`${classes.icon} ${customStyles.rotateAnimation}`} fontSize="large" />
				</Grid>
				<Grid item>
					<Typography className={classes.title} variant="h3">Estamos te redirecionando...</Typography>
				</Grid>
				<Grid item>
					<Typography className={classes.subtitle} variant="subtitle1">
						Só um momento que estamos procurando um atendente para você.
					</Typography>
				</Grid>
			</Grid>
		</Container>
	)
}

export default RedirectToWhatsAppFromATrackableLink
